import Image, { ImageProps } from 'next/image';
import { CustomImage } from 'components/shared/custom-image';

const isAbsoluteImageSrc = (src: string) =>
  src.startsWith('https://') || src.startsWith('http://');

export const BvUpsellPlanImage = ({
  src,
  alt,
  ...rest
}: ImageProps & { src: string }) => {
  if (isAbsoluteImageSrc(src)) {
    return <Image src={src} alt={alt} {...rest} />;
  }
  return <CustomImage src={src} alt={alt} {...rest} />;
};
